import React from 'react';
import { Icon } from '../../components/icon/Icon';
import { FlexWrapper } from '../../components/FlexWrapper';
import {S} from './Footer_Styles'

const socialItemsData = [
    {
        iconId: "social"},
        {
            iconId: "social1"
        },
        {
            iconId: "social2"
        },
        {
            iconId: "social3"
        }
]

export const Footer: React.FC = () => {
    return (
        <S.Footer>
            <FlexWrapper direction={"column"} align={"center"} >
                <S.Name>Ainur</S.Name>
                <S.SocialList>
                    {socialItemsData.map((s, index)=>{
                        return(
                            <S.SocialItem key={index}>
                        <S.SocialIcon>
                            <Icon height={"40"} width={"40"} viewBox={"0 0 40 40"} iconId={s.iconId} />
                        </S.SocialIcon>
                    </S.SocialItem>
                        )
                    })}
                    
                </S.SocialList>
                <S.Copyright>2025 Ainur Taganov, All Rights Reserved.</S.Copyright>
            </FlexWrapper>
        </S.Footer>
    );
};
